import { Tokens } from '../../../theming/types/index'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    placeholder: {
      avatar: {
        color: tokens.fontColorInverse,

        '& > svg': {
          borderRadius: '50%',
          fill: tokens.iconColorInverse,
          height: '100%',
          overflow: 'hidden',
          width: '100%',
        },
      },
    },

    sizeXxlarge: {
      avatar: {
        // @ts-expect-error Does not exist in Ink
        fontSize: tokens.fontHeadingXL.fontSize,
        height: '96px',
        width: '96px',
      },
    },

    sizeXlarge: {
      avatar: {
        // @ts-expect-error Does not exist in Ink
        fontSize: tokens.fontHeadingXL.fontSize,
        height: '72px',
        width: '72px',
      },
    },

    sizeLarge: {
      avatar: {
        fontSize: tokens.fontHeadingM.fontSize,
        height: '48px',
        width: '48px',
      },
    },

    sizeMedium: {
      avatar: {
        fontSize: tokens.fontHeadingM.fontSize,
        height: '36px',
        width: '36px',
      },
    },

    sizeSmall: {
      avatar: {
        fontSize: tokens.fontHeadingS.fontSize,
        height: '28px',
        width: '28px',
      },
    },
  } as const
}
